import axios from "axios";
import APIBaseURL from '../../../AppConfig/AppConfig.json'
import { useNavigate, useParams } from "react-router-dom";

const axiosAuth=()=>{
    const navigate = useNavigate();
    const token = localStorage.getItem('access_token')
    const { tenant } = useParams<{ tenant: string }>();
     const baseURL = window.location.origin.endsWith('/')
    ? window.location.origin
    : `${window.location.origin}/`;

    const axiosInstance = axios.create({
        baseURL: APIBaseURL.apiBaseUrl,
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Tenant": tenant || "",
          "X-App": baseURL,
        },
      });
    
    // Interceptor to conditionally modify headers before each request
  axiosInstance.interceptors.request.use((config) => {
      // Redirect if token is missing
      if (!token) {
        navigate(`/${tenant}/SignIn`);
        return Promise.reject({ message: "Unauthorized - No Token Found" });
    }
     // Skip headers for blob URLs
     if (config.url?.startsWith("blob:")) {
      delete config.headers.Authorization;
      delete config.headers["X-Tenant"];
      delete config.headers["X-App"];
    }
 
    // Check if Content-Type needs to be set
    if (config.headers && config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  return axiosInstance;
};

export default axiosAuth